import { Component } from "components/common";

/**
 * Eine Klasse zur Erstellung von HTML `<button>` Elementen.
 *
 * @example
 * Das folgende Beispiel erstellt ein HTML `<button>` Element.
 *
 * Erstelle ein neues HTML `<button>` Element.
 *
 * ```typescript
 * import { Button } from "components/common/button";
 *
 * const button = new Button();
 * ```
 *
 * Konfiguriere das HTML `<button>` Element durch Method Chaining.
 *
 * ```typescript
 * button
 *     .withID("button")
 *     .withClass("button");
 * ```
 *
 * Rendere nun das HTML `<button>` Element in das DOM.
 *
 * ```typescript
 * document.getElementById("root")
 *     ?.replaceChildren(button.render());
 * ```
 *
 * @public
 */
class Button extends Component<HTMLButtonElement> {
  /**
   * Erstellt ein neues HTML `<button>` Element.
   */
  constructor() {
    super(document.createElement("button"));
  }

  /**
   * Fügt einen Typ hinzu.
   *
   * @param type - Ein Typ.
   * @returns Das HTML `<button>` Element mit dem Typ.
   *
   * @public
   */
  public withType(type: HTMLButtonElement["type"]) {
    this.element.type = type;

    return this;
  }
}

export { Button };
